export default __webpack_public_path__ + "static/lorawan-00abc3cb9f0cf781585282979f260b73.png";